import planUpsells from '../../data/planUpsells.json'

const getPlanUpsells = () => {
  if (typeof planUpsells === 'undefined') {
    return []
  } else {
    return planUpsells
  }
}

interface PlanUpsell {
  active: boolean
  planFrom: {
    id: string
  }
  planTo: {
    category: {
      type: string
    }
  }
}

export const getPlanUpsell = (id: string, isRetail: boolean) => {
  const upsell = getPlanUpsells().find(
    (mapping: PlanUpsell) =>
      mapping.planFrom.id === id &&
      mapping.active &&
      (mapping.planTo.category.type !== 'retail') === isRetail
  )

  const retailUpsell = getPlanUpsells().find(
    (mapping: PlanUpsell) =>
      mapping.planFrom.id === id &&
      mapping.active &&
      (mapping.planTo.category.type === 'retail') === isRetail
  )
  return retailUpsell || upsell || null
}
